<template>
  <div
    class="modal fade"
    id="editReviewCategoryModal"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content m-t100">
        <div class="modal-header">
          <h3 class="modal-title" id="myModalLabel">Category Details</h3>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form class="content-form">
            <div class="form-group position-relative">
              <label class="control-label"
                >Category<span class="text-danger"> *</span></label
              >
              <input
                type="text"
                class="form-control"
                name="review-category-name"
                v-validate="'required|regex:^[^-\s][a-zA-Z ]*$'"
                data-vv-as="Review Category Name"
                data-vv-validate-on="blur|input"
                :class="{ invalid: errors.first('review-category-name') }"
                v-model="data.review_category_name"
                maxlength="30"
              />
              <span
                v-if="errors.first('review-category-name')"
                class="valid-feedback alert-danger"
                >{{ errors.first("review-category-name") }}</span
              >
            </div>
            <div class="form-group position-relative">
              <label class="control-label"
                >Category Description<span class="text-danger"> *</span></label
              >
              <input
                type="text"
                class="form-control"
                name="review-category-description"
                v-validate="'required'"
                data-vv-as="Review Category Description"
                data-vv-validate-on="blur|input"
                v-model="data.review_category_description"
                :class="{
                  invalid: errors.first('review-category-description'),
                }"
              />
              <span
                v-if="errors.first('review-category-description')"
                class="valid-feedback alert-danger"
                >{{ errors.first("review-category-description") }}</span
              >
            </div>
          </form>
        </div>
        <div class="modal-footer text-center">
          <button
            :disabled="$v.data.$invalid"
            type="button"
            class="btn btn-cp"
            @click="updateReviewCategory"
            data-dismiss="modal"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { required, maxLength } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      data: {
        id: null,
        review_category_name: "",
        review_category_description: "",
        status: "active",
      },
    };
  },

  validations() {
    const data = {
      review_category_name: {
        required,
        maxLength: maxLength(30),
        reviewCategoryNameValidator: this.reviewCategoryNameValidator,
      },
      review_category_description: {
        required,
      },
    };
    return {
      data,
    };
  },
  computed: {
    ...mapGetters({
      reviewCategoryData: "$_manage_reviews/editReviewCategoryModal",
    }),
  },
  watch: {
    reviewCategoryData(value) {
      this.data.id = value.id;
      this.data.review_category_name = value.review_category_name;
      this.data.review_category_description = value.review_category_description;
    },
  },
  methods: {
    updateReviewCategory() {
      this.$store.dispatch("$_manage_reviews/editReviewCategory", this.data);
    },

    reviewCategoryNameValidator(value) {
      return /^[^-\s][a-zA-Z ]*$/.test(value);
    },
  },
  beforeDestroy() {
    $("#editReviewCategoryModal").modal("hide");
    $(".modal-backdrop").hide();
    $("body").removeClass("modal-open");
  },
};
</script>
<style scoped></style>
